/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { ImageURL } from "../../../../Environment/Environment";
import defaultImg from "../../../../assets/img/thumbnail.png";
import MoonLoader from "react-spinners/MoonLoader";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Pagination from "../../../../Helper/Pagination";
import Switch from "@mui/material/Switch";

export default function GalleryWallListing() {
  const [GalleryWalllist, setGalleryWalllist] = useState();

  const [error, setError] = useState(false);
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");

  const [size, setsize] = useState("");
  const [Price, setPrice] = useState("");

  // const [status, setstatus] = useState("");
  const [selectedState, setselectedState] = useState("");
  const [submitLoader, setsubmitLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const { type } = useParams();

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  useEffect(() => {
    setsize(selectedState?.size);
    setPrice(selectedState?.price);
    setLocalImgPath(
      selectedState?.frame
        ? selectedState?.frame
        : selectedState?.image
        ? selectedState?.image
        : ""
    );
    setImage(
      selectedState?.frame
        ? selectedState?.frame
        : selectedState?.image
        ? selectedState?.image
        : ""
    );
  }, [selectedState]);

  const submit = (e) => {
    e.preventDefault();
    if (!Price) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const formdata = new FormData();
    formdata.append("price", Price);
    formdata.append("image", Image);
    formdata.append("id", selectedState?.id);
    const route =
      type === "gallery_wall"
        ? API_URL.UPDATE_GALLERY_LIST
        : API_URL.UPDATE_STORY_LIST;
    PostFormData(route, formdata).then((res) => {
      setsubmitLoader(false);
      if (res?.data?.status) {
        showSuccessAlert(res?.data?.message, getList);
        resetFunc();
        document.getElementById("closeEditModal").click();
      } else {
        showErrorAlert(res.data?.message);
      }
    });
  };

  function resetFunc() {
    //  setselectedState('')
    setImage("");
    setLocalImgPath(defaultImg);
    setError(false);
  }
  const getList = () => {
    setLoading(true);
    const route =
      type === "gallery_wall"
        ? `${API_URL.GET_GALLERY_LIST}?status=All&searchkey=${search_key}`
        : `${
            API_URL.GET_STORY_LIST
          }?status=All&size=${10}&page=${currentPage}&sorting='sortingKey|desc'&searchkey=${search_key}`;
    GetService(route).then((res) => {
      if (res?.data?.status === true) {
        if (type === "gallery_wall") {
          setGalleryWalllist(res?.data?.data);
        } else {
          setGalleryWalllist(res?.data?.data?.item);
          SetTotalPageCount(res?.data?.data?.totalPages);
          SetTotalCount(res?.data?.data?.totalItems);
          setCount(res?.data?.data?.currentPage * 10);
        }
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };
  useEffect(() => {
    getList();
  }, [search_key, currentPage, type]);

  useEffect(() => {
    setGalleryWalllist("");
    setCurrentPage(0);
  }, [type]);

  const changeStatus = async (id, status) => {
    const data = {};
    if (type === "gallery_wall") {
      data.id = id;
      data.status = status === "Active" ? "InActive" : "Active";
    } else {
      data.id = id;
      data.status = !status;
    }
    const route =
      type === "gallery_wall"
        ? API_URL.UPDATE_GALLERY_LIST
        : API_URL.UPDATE_STORY_LIST;
    PostService(route, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(`Status ${(status === "Active"||status === true) ? "inactive" : "active"} successfully`, getList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>
                {type === "gallery_wall" ? "Gallery Wall List" : "Story Canvas List"}{" "}
              </h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  {type === "gallery_wall" ? "Gallery Wall List" : "Story Canvas List"}
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  {!loading && (
                    <div class="table-responsive mt-4">
                      <table class="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Image</th>
                            <th className="text-center">Size</th>
                            <th className="text-center">price ($)</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {GalleryWalllist?.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + S_No_Count + 1}</td>
                              <td className="text-center">
                                <img
                                  src={
                                    item?.frame
                                      ? item?.frame
                                      : item?.image
                                      ? item?.image
                                      : ""
                                  }
                                  alt="..."
                                  onError={(e) => {
                                    e.target.src = defaultImg;
                                  }}
                                />
                              </td>
                              <td className="text-center">{item?.size}</td>
                              <td className="text-center">{item?.price}</td>
                              <td className="text-center">
                                <label
                                  className={
                                    item?.status === "Active" ||
                                    item?.status === true
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {item?.status === true ||
                                  item?.status === "Active"
                                    ? "Active"
                                    : "Inactive"}
                                </label>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={
                                      item?.status === "Active" ||
                                      item?.status === true
                                    }
                                    onChange={() => {
                                      changeStatus(item.id, item.status);
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>
                                <span
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setselectedState(item);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {GalleryWalllist && GalleryWalllist?.length === 0 && (
                          <tr>
                            <td colSpan="6" className="text-center">
                              <h6 className="p-3"> No Data Found </h6>
                            </td>
                          </tr>
                        )}
                      </table>
                    </div>
                  )}
                  {loading ? (
                    <div className="LoaderSpinner">
                      <MoonLoader
                        color={"#003bff"}
                        loading={loading}
                        speedMultiplier={0.6}
                        size={50}
                      />
                      <div>Loading... Please wait.</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {type !== "gallery_wall" && (
                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4
                className="modal-title text-capitalize"
                id="exampleModalLabel"
              >
                Edit {type}
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="form-group col-12">
                    <label>Size</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="size"
                      value={size}
                      readOnly
                    />
                  </div>

                  <div className="form-group col-12">
                    <label>Price</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Price"
                      value={Price}
                      onChange={(e) => setPrice(e?.target.value)}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <div className="row d-flex align-items-center justify-content-center">
                    {/* <div className="col-md-5 col-6">
                      <span>
                        <span className="btn btn-primary col-12">
                          Select Image
                          <input
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            className="btn-input position-absolute"
                            style={{ opacity: 0 }}
                            onChange={(e) => onimageUpload(e)}
                          />
                        </span>
                      </span>

                      {error && !Image && (
                        <div className="error mt-1">Image is required</div>
                      )}
                    </div> */}
                    <div className="">
                      <img
                        src={ImgPath ? ImgPath : ""}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-3"></div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>

                <button
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                  onClick={(e) => submit(e)}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
